import { NavLink } from "react-router";

import { ChevronRight } from "@mui/icons-material";
import {
  Box,
  Breadcrumbs,
  SxProps,
  Typography,
  useMediaQuery
} from "@mui/material";

import { theme } from "@/src/theme/theme";

export type Breadcrumb = {
  id: string;
  label: string;
  url?: string;
};

interface BreadcrumbPanelProps {
  crumbs: Breadcrumb[];
  sx?: SxProps;
}

const BreadcrumbPanel = (props: BreadcrumbPanelProps) => {
  const { crumbs, sx } = props;
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        ml: isMobile ? 0 : 4,
        mt: isMobile ? 2 : 4,
        mb: isMobile ? 1 : 0,
        a: {
          textDecoration: "none"
        },
        alignItems: "center",
        ...sx
      }}
    >
      <Breadcrumbs
        separator={
          <ChevronRight
            sx={{
              fontSize: theme.typography.body1.fontSize,
              color: theme.palette.text.secondary
            }}
          />
        }
      >
        {crumbs.map((crumb: Breadcrumb) => {
          if (crumb.url) {
            return (
              <NavLink id={crumb.id} key={crumb.id} to={crumb.url}>
                <Typography
                  id={crumb.id}
                  key={crumb.id}
                  variant="caption"
                  color="primary"
                  sx={{
                    fontWeight: theme.typography.fontWeightRegular,
                    cursor: "pointer",
                    textDecoration: "underline",
                    textUnderlineOffset: "2px"
                  }}
                >
                  {crumb.label}
                </Typography>
              </NavLink>
            );
          }
          return (
            <Typography
              id={crumb.id}
              key={crumb.id}
              variant="caption"
              color="secondary"
              sx={{
                fontWeight: theme.typography.fontWeightBold
              }}
            >
              {crumb.label}
            </Typography>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};

export default BreadcrumbPanel;
